'use strict'
import scrollTo from './scroll-to';

const getOffsetTop = (element) => {
  let offsetTop = 0;
  while(element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
}

const heroGovernorsGreeting = {
  $hero: null,
  $layerBack: null,
  $layerMid: null,
  $layerFront: null,
  $pageContentWrap: null,
  $mobileHeader: null,

  heroTop: 0,
  heroInViewPort: null,
  viewportHeight: 0,
  mobileHeaderHeight: 0,
  pageContentTop: 0,
  resizeTimer: null,
  observer: null,

  init(){
    this.$hero = document.querySelector('.governors-greeting-hero');
    this.$layerBack = document.querySelector('.governors-greeting-hero__layer-back');
    this.$layerMid = document.querySelector('.governors-greeting-hero__layer-mid');
    this.$layerFront = document.querySelector('.governors-greeting-hero__layer-front');
    this.$mobileHeader = document.querySelector('.mobile-header');
    this.$pageContentWrap = document.querySelector('.page-content-wrap');

    if(!this.$hero || !this.$layerBack || !this.$layerMid || !this.$layerFront){
      return;
    }

    const $scrollToArticleLink = this.$hero.querySelector('a[href="#article"]');
    if($scrollToArticleLink){
      $scrollToArticleLink.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();

        const $scrollToEl = Array.from(this.$hero.parentElement.children).find($el => $el !== this.$hero && !$el.classList.contains('governors-greeting-quote-box'));

        if($scrollToEl){
          scrollTo($scrollToEl);
        }
      })
    }

    if(!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      // No IntersectionObserver or user prefers reduced motion
      if(this.$layerFront){
        this.$layerFront.style.opacity = '';
        this.$layerFront.style.transitionProperty = 'none';
      }
      return
    }

    this.$layerFront.style.opacity = 1;
    this.$layerBack.style.height = '120%';
    this.$layerMid.style.height = '110%';

    this.getPositions();
    this.updateHero(true);

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        this.heroInViewPort = entry.isIntersecting;
      });
    });

    // Add observer and event listeners

    this.observer.observe(this.$hero);

    document.addEventListener('scroll', () => {
      this.updateHero()
    }, {
      passive: true
    });

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.getPositions();
        this.updateHero();
      }, 100);
    });
  },

  getPositions(){
    this.mobileHeaderHeight = this.$mobileHeader.offsetHeight;
    this.pageContentTop = this.$pageContentWrap.offsetTop;
    this.$hero.style.height = `calc(100vh - ${this.mobileHeaderHeight || this.pageContentTop}px)`;
    this.$hero._pageTop = getOffsetTop(this.$hero);
    this.$hero._height = this.$hero.offsetHeight;
    this.$layerBack._heightDiff = this.$hero._height - this.$layerBack.offsetHeight;
    this.$layerMid._heightDiff = this.$hero._height - this.$layerMid.offsetHeight;
    this.viewportHeight = document.documentElement.offsetHeight;
  },

  getTime(){
    const documentScrollTop = document.documentElement.scrollTop;
    const heroBottomPos = this.$hero._pageTop + this.$hero._height - documentScrollTop - this.mobileHeaderHeight;
    const totalSpace = this.viewportHeight + this.$hero._height + this.$hero._pageTop - this.mobileHeaderHeight;
    let multiplier = 0;

    if(heroBottomPos < 0){
      multiplier = 0;
    } else if(heroBottomPos > this.viewportHeight){
      multiplier = 1;
    } else {
      multiplier = 1 / totalSpace * heroBottomPos;
    }

    return 1 - multiplier;
  },

  stretchTime(time, timeFrom, timeTo){
    const timeDiff = timeTo - timeFrom;
    const stretchedTime = 1 / timeDiff * Math.min(1, Math.max(0, time - timeFrom));
    return stretchedTime;
  },

  updateHero(force){
    if(!force && !this.heroInViewPort) return;

    const time = this.getTime(); // Time is between 0 and 1 where 0 = below the viewport and 1 = above the viewport (0.5 middle of the viewport)

    // Hero is designed to change the parallax effect direction after certain point
    // That point is about 0.6 (60%) of time

    if(time < 0.6){
      // Because hero is at the top of the content area and its height is 100% (relative) so its staring time is "at the middle" = 0.5 (50%)
      // So the working time is 0.5 - 0.6 > stretch that to 0 - 1
      const relTime = this.stretchTime(time, 0.5, 0.6);
      this.$layerBack.style.transform = `translateY(${ this.$layerBack._heightDiff * relTime }px)`;
      this.$layerMid.style.transform = `translateY(${ this.$layerMid._heightDiff * relTime }px)`;
      this.$layerFront.style.transform = `translateY(${ this.$layerMid._heightDiff * relTime }px)`;
    } else {
      // The working time is 0.6 - 1 > stretch that to 0 - 1
      const relTime = this.stretchTime(time, 0.6, 1);
      const oppositeRelTime = 1 - relTime * 3;
      this.$layerBack.style.transform = `translateY(${ this.$layerBack._heightDiff * oppositeRelTime }px)`;
      this.$layerMid.style.transform = `translateY(${ this.$layerMid._heightDiff * oppositeRelTime }px)`;
      this.$layerFront.style.transform = `translateY(${ this.$layerMid._heightDiff * oppositeRelTime }px)`;
    }

  }
};

module.exports = heroGovernorsGreeting;
